<div class="internal-files-container">

    <!-- File grid -->
    <div class="files-grid">

        <div class="file-row" *ngFor="let file of internalFiles; let i = index">
            <button type="button" class="delete-file-btn" [attr.aria-label]="'permit.manage.internal_files.delete_file' | translate" (click)="confirmDelete(i); $event.stopPropagation()">
                <mat-icon>close</mat-icon>
            </button>

            <ng-container *ngIf="isImage(file)">
                <button type="button" class="file-preview" [attr.aria-label]="('permit.manage.internal_files.open_file' | translate) + ' ' + getFileName(file)" (click)="openFile(file); $event.stopPropagation()">
                    <img [src]="file.url" [alt]="getFileName(file)">
                </button>
            </ng-container>

            <ng-container *ngIf="!isImage(file)">
                <button type="button" class="file-preview document-icon" [attr.aria-label]="('permit.manage.internal_files.open_file' | translate) + ' ' + getFileName(file)" (click)="openFile(file); $event.stopPropagation()">
                    <img *ngIf="isDocumentPdf(file)" src="assets/images/pdf-file.svg" alt="PDF">
                    <img *ngIf="isDocumentWord(file)" src="assets/images/word-file.svg" alt="Word">
                    <img *ngIf="isDocumentExcel(file)" src="assets/images/sheets-file.svg" alt="Excel">
                    <mat-icon *ngIf="!isDocumentPdf(file) && !isDocumentWord(file) && !isDocumentExcel(file)">insert_drive_file</mat-icon>
                </button>
            </ng-container>

            <div class="file-name">{{ getFileName(file) }}</div>
        </div>

        <!-- Upload in-progress placeholder -->
        <div class="file-row" *ngIf="uploading">
            <div class="file-uploading"></div>
        </div>

        <!-- Add file tile -->
        <div class="file-row">
            <button
                type="button"
                class="add-file-btn"
                [class.disabled]="uploading"
                [disabled]="uploading"
                [attr.aria-label]="'permit.manage.internal_files.add_file' | translate"
                (click)="fileInput.click()">
                <input
                    #fileInput
                    id="internal-file-input"
                    type="file"
                    class="hidden-file-input"
                    (change)="onFileSelected($event)"
                    accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                    [disabled]="uploading"
                    [attr.aria-label]="'permit.manage.internal_files.add_file' | translate"
                    tabindex="-1">
                <mat-icon>add</mat-icon>
            </button>
        </div>

    </div>



</div>
